/**
 * 强密码规则（与后端 `auth::password::validate_strength` 保持一致）：
 *   - 至少 8 位
 *   - 必须同时包含数字、字母、符号（非字母数字非空白）
 */
export function validatePassword(plain: string): string | null {
  if (plain.length < 8) return "密码至少 8 位";
  if (plain.length > 64) return "密码不得超过 64 位";
  const hasDigit = /\d/.test(plain);
  const hasAlpha = /[A-Za-z]/.test(plain);
  const hasSymbol = /[^A-Za-z0-9\s]/.test(plain);
  if (!(hasDigit && hasAlpha && hasSymbol)) return "密码必须同时包含数字、字母和符号";
  return null;
}

export const PASSWORD_HINT = "至少 8 位，必须同时包含数字、字母和符号";
